import http from 'conversations-http/clients/http';
import { mapAssociationsResponseToSupplementalObjects } from '../operators/mapAssociationsResponseToSupplementalObjects';
export const getInsertCapabilitiesData = ({
  threadId
}) => http.get(`messages/v2/associations/${threadId}`).then(response => mapAssociationsResponseToSupplementalObjects(response));